import { Routes, Route } from "react-router-dom";

import List from "./list";
import View from "./view";
import Create from "./create";

export default function Users() {
  return (
    <Routes>
      <Route path="/:id" Component={View} />
      <Route path="/create" Component={Create} />
      <Route path="/" Component={List} />
    </Routes>
  );
}
